var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "permission-box box" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("label", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("preRegistration.step4.front.auth.title"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "row row-gap-2" }, [
      _c("li", { staticClass: "flex-align-center" }, [
        _c("b", [_vm._v("Cam")]),
        _vm._v(" "),
        _c("span", { class: [_vm.checkedCamera ? "allow" : ""] }, [
          _vm._v(
            _vm._s(
              _vm.checkedCamera
                ? _vm.$t("preRegistration.step4.front.auth.grant")
                : _vm.$t("preRegistration.step4.front.auth.deny")
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "flex-align-center" }, [
        _c("b", [_vm._v("Mic")]),
        _vm._v(" "),
        _c("span", { class: [_vm.checkedMicrophone ? "allow" : ""] }, [
          _vm._v(
            _vm._s(
              _vm.checkedMicrophone
                ? _vm.$t("preRegistration.step4.front.auth.grant")
                : _vm.$t("preRegistration.step4.front.auth.deny")
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }